define([
	'jquery',
    '../reviews',
    '../carousel_mobile',
	'../console',
	'../globals'
], function($, reviews, carouselMobile, console, globals) {
	'use strict';

	var _template = 'house';
	var tm = require('../vendor/gsap/gsap').TweenMax;
    // var topCarousel = require('../carousel');
    const videoPlayer = require('../video');
    const loadGoogleMapsApi = require('load-google-maps-api');

    // const photoswipeFromDom = require('../vendor/photoswipe-init');
    const PhotoSwipeLightbox = require('../vendor/photoswipe/photoswipe-lightbox.umd.min');
    const PhotoSwipe = require('../vendor/photoswipe/photoswipe.umd.min');
    let myGallery;

    function enableEventHandlers() {
        // topCarousel.activate();
        videoPlayer.activate();

        enableMap();
        reviews.truncate();

        if ($('.js-gallery_images').length) {
            // myGallery = photoswipeFromDom('.js-gallery_images');
            myGallery = new PhotoSwipeLightbox({
                gallery: '.js-gallery_images',
                children: 'a',
                pswpModule: PhotoSwipe,
                bgOpacity: 0.7,
                // spacing: 0.5, // 50% of viewport width
                // closeOnVerticalDrag: false,
                // showAnimationDuration: 1000,
                // hideAnimationDuration: 1000,
            });
            myGallery.init();

            carouselMobile.init();
        }
    }

    function disableEventHandlers() {
        // topCarousel.deactivate();
        videoPlayer.deactivate();

        if (myGallery && myGallery.destroy === 'function') {
            myGallery.destroy();
        }
    }

    function initMap() {
        var $maps = $('.map__item');
        if ($maps.length) {
            FieldMap.initOneForAll('.map__all', $maps);
        }
    }

    var initializeMap = function() {
        var $mapCanvas = $('.map');

        var myLatlng = new google.maps.LatLng($mapCanvas.data('lat'), $mapCanvas.data('lng'));
        var zoom = $mapCanvas.data('zoom');

        var mapOptions = {
            zoom: zoom,
            zoomControl: true,
            center: myLatlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            panControl: false,
            backgroundColor: '#e8e9ea',
            streetViewControl: false,
            scaleControl: false,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.SMALL,
                position: google.maps.ControlPosition.RIGHT_TOP
            }
        };

        google.maps.visualRefresh = true;

        var map = new google.maps.Map($mapCanvas.get(0), mapOptions);

        var contentString = '<div id="info-window-content">'+
            '<div class="info-window-title">inakileite</div>'+
            '<div>' + $mapCanvas.data('address') + '</div>' +
            '</div>';

        var infowindow = new google.maps.InfoWindow({
            content: contentString
        });

        var marker = new google.maps.Marker({
            position: myLatlng,
            map: map,
            title: 'inakileite'
        });

        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open(map, marker);
        });
    }

    var enableMap = function() {
        var $maps = $('.map');
        if ($maps.length) {
            loadGoogleMapsApi({
                key: 'AIzaSyDeb2K_4l5OU8-fCXLEGnJVI0Uy3YFzaLI',
                language: $('html').attr('lang')
            })
                .then(function (googleMaps) {
                    initializeMap();
                })
                .catch(function (error) {
                    console.error(error);
                });
        }
    };

	var animateIn = function(callback) {
		if ($('.viewport').data('template') !== _template) {
            return false;
        }

        enableEventHandlers();

        tm.to($('.page-row-expanded'), 0.3, {
            css: {opacity: 1}, onComplete: function () {
                if (callback && typeof (callback) === "function") {
                    return (callback());
                }
            }
        });
	};

	var animateOut = function(callback) {
		if ($('.viewport').data('template') !== _template) {
            return false;
        }

        disableEventHandlers();

        tm.to($('.page-row-expanded'), 0.3, {
            css: {opacity: 0}, onComplete: function () {
                if (callback && typeof (callback) === "function") {
                    return (callback());
                }
            }
        });
	};

	return {
		animateIn: animateIn,
		animateOut: animateOut
	}
});